export class Assunto {
    idAssunto: any;
    codAssunto: any;
    dsAssunto: any;
    flAtivo: any;

    constructor() {
        this.idAssunto = "";
        this.codAssunto = "";
        this.dsAssunto = "";
        this.flAtivo = "";
    }
}


// WEBPACK FOOTER //
// ./src/models/Assunto.ts